import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import i18n from "../../i18n/i18n";
const BASE_URL = process.env.REACT_APP_BASE_URL;

// all business sector credits
export const fetchBusinessSectorCredits = createAsyncThunk(
  "business_sector_credits/fetchAll",
  async (arg, { rejectWithValue }) => {
    const params =
      arg && typeof arg === "object" && !Array.isArray(arg)
        ? arg
        : { page: Number(arg) || 1 };
    try {
      const response = await axios.get(`${BASE_URL}/business-sectors/credit-limit`, {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          "Content-Type": "application/json",
          Lang: i18n.language,
        },
        params,
      });
      return response.data; // Return the whole response including pagination
    } catch (error) {
      const message = error.response?.data?.message || "Failed load data";
      return rejectWithValue(message);
    }
  }
);

const BusinessSectorCreditsSlice = createSlice({
  name: "business_sector_credits",
  initialState: {
    business_sector_credits: [],
    isLoading: false,
    error: null,
    success: null,
    pagination: null,
  },
  reducers: {
    clearState: (state) => {
      state.error = null;
      state.success = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchBusinessSectorCredits.pending, (state) => {
        state.isLoading = true;
        state.error = null;
      })
      .addCase(fetchBusinessSectorCredits.fulfilled, (state, action) => {
        state.isLoading = false;
        state.business_sector_credits = action.payload?.data?.data || [];
        state.pagination = action.payload?.data?.pagination || null;
      })
      .addCase(fetchBusinessSectorCredits.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload || "Failed to load data";
      });
  },
});

export const { clearState } = BusinessSectorCreditsSlice.actions;
export default BusinessSectorCreditsSlice.reducer;
